module.exports = __webpack_public_path__ + "img/1.dde3ccee.png";